import 'react';
import 'reakit-system/useToken';
import 'color';
import './isLight.js';
export { g as getPalette, d as usePalette } from '../ref-bbcfbae4.js';
